import { fork, all } from 'redux-saga/effects';
import watchGetLoginPageLogoURL from './logo/logo';
import watchDoStandardLogin from './login/standardLogin/standardLogin';
import watchDoSSOLogin from './login/ssoLogin/ssoLogin';
import watchGetIdentityProviders from './identityProviders/identityProviders';
import watchPasswordRecovery from './passwordRecovery/passwordRecovery';
import watchPageFooterInfo from '../shared/sagas/pageFooter/pageFooter';
import watchGetSSOError from './ssoError/ssoError';

export default function* rootSaga() {
    yield all([
        fork(watchGetLoginPageLogoURL),
        fork(watchDoStandardLogin),
        fork(watchDoSSOLogin),
        fork(watchGetIdentityProviders),
        fork(watchPasswordRecovery),
        fork(watchPageFooterInfo),
        fork(watchGetSSOError),
    ]);
}
